import { useChecklistContext } from '../../../../contexts';
import { ChecklistSection } from '../../ChecklistPage';
import { PaddedGenericSection } from '../GenericSection';

export const IncomeRefName = 'income';

export default function IncomeSection() {
  const { checklist } = useChecklistContext();

  const {
    income,
  } = checklist ?? {};

  return (
    <PaddedGenericSection
      refName={IncomeRefName}
      section={ChecklistSection.INCOME}
      checklistItem={income}
    >
      <p>level 0</p>
    </PaddedGenericSection>
  );
}
